import { TextField, useFormContext } from '@calendly/form'
import { BodyText } from '@calendly/ui/components/typography'

const EventLinkLocked = ({ profileSlug }) => {
  const { values: { slug } } = useFormContext()

  return (
    <BodyText color="muted">
      {`calendly.com/${profileSlug || ''}/`}
      <BodyText inline color="standard">{slug}</BodyText>
    </BodyText>
  )
}

const EventLinkField = ({ profileSlug, v3Style }) => (
  <>
    <BodyText color="muted" size={v3Style ? 'small' : 'medium'}>{`calendly.com/${profileSlug || ''}/`}</BodyText>
    <TextField id="slug-field" name="slug" aria-labelledby="event-link-id" />
  </>
)

export const EventLink = ({ isLocked, ...props }) => (
  !isLocked ? <EventLinkField {...props} /> : <EventLinkLocked {...props} />
)
